import {
  FETCH_BUYERS_LISTING_SUCCESS,
  FETCH_BUYERS_LISTING_FAILURE,
  RESET,
} from "./buyersTypes";

const initialState = {
  allBuyers: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BUYERS_LISTING_SUCCESS:
      return {
        allBuyers: action.payload,
        error: null,
      };
    case FETCH_BUYERS_LISTING_FAILURE:
      return {
        allBuyers: [],
        error: action.payload,
      };
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
